"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSearchActionTypes = _interopRequireDefault(require("../../flux/elasticSearch/createSearchActionTypes"));

var _ActionNamespaces = _interopRequireDefault(require("crm_data/actions/ActionNamespaces"));

var DEAL_PIPELINE_SEARCH = _ActionNamespaces.default.DEAL_PIPELINE_SEARCH;

var _default = (0, _createSearchActionTypes.default)(DEAL_PIPELINE_SEARCH);

exports.default = _default;
module.exports = exports.default;